import { Box } from '@chakra-ui/react';
import Hls from 'hls.js';
import React, { useEffect, useRef } from 'react';

type Props = {
  id: string;
  src: string;
  isPaused?: boolean;
  className?: string;
};

function HlsPlayer({ src, id, className }: Readonly<Props>) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    let hls: Hls;
    const video: HTMLVideoElement = videoRef.current as HTMLVideoElement;

    if (Hls.isSupported()) {
      hls = new Hls();
      hls.loadSource(src);
      hls.attachMedia(video);

      hls.on(Hls.Events.ERROR, function (event, data) {
        console.error('HLS error:', data);
      });
    } else {
      console.error('Hls not supported');
    }

    return () => {
      hls.destroy();
    };
  }, [src]);

  return (
    <Box id={id} width="100%" height="100%" className={`hls-player-${className}`}>
      <video ref={videoRef} style={{ width: '100%', height: '100%', background: 'black' }} autoPlay />
    </Box>
  );
}

export default HlsPlayer;
